import GoogleReviews from "@/components/site/GoogleReviews";
import HomeHero from "@/components/site/home/HomeHero";
import HomePhilosophy from "@/components/site/home/HomePhilosophy";
import HomeAboutMethod from "@/components/site/home/HomeAboutMethod";
import HomeSpecialties from "@/components/site/home/HomeSpecialties";
import HomeModalities from "@/components/site/home/HomeModalities";
import HomeBenefits from "@/components/site/home/HomeBenefits";
import HomePress from "@/components/site/home/HomePress";
import HomeFinalCta from "@/components/site/home/HomeFinalCta";
import useSeo from "@/lib/useSeo";

const Home = () => {
  useSeo({
    title: {
      es: "Yoga Oncológico, Fibromialgia y Fatiga Crónica | Método TAO",
      ca: "Ioga Oncològic, Fibromiàlgia i Fatiga Crònica | Mètode TAO",
    },
    description: {
      es: "Acompañamiento cuerpo-mente para cáncer, fibromialgia, fatiga crónica y ansiedad. Online España/LATAM y presencial en Barcelona. Primera sesión gratuita.",
      ca: "Acompanyament cos-ment per a càncer, fibromiàlgia, fatiga crònica i ansietat. Online Espanya/LATAM i presencial a Barcelona. Primera sessió gratuïta.",
    },
    path: "/",
  });

  return (
    <div className="bg-ivory">
      <HomeHero />
      <HomePhilosophy />
      <HomeAboutMethod />
      <HomeSpecialties />
      <HomeModalities />
      <HomeBenefits />
      <HomePress />
      <GoogleReviews />
      <HomeFinalCta />
    </div>
  );
};

export default Home;
